module.exports = __webpack_public_path__ + "img/GalacticJonah-petrified.840eeac4.jpg";